var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 229.379,
    height: 237.51,
    viewBox: "0 0 229.379 237.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5091",
    "data-name": "Rectangle 5091",
    width: 229.379,
    height: 237.51,
    rx: 20,
    transform: "translate(1544.621 746)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5090",
    "data-name": "Rectangle 5090",
    width: 233.079,
    height: 232.822,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_86",
    "data-name": "Mask Group 86",
    transform: "translate(-1544.621 -746)",
    opacity: 0.12,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13188",
    "data-name": "Group 13188",
    transform: "translate(1540.921 764.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13186",
    "data-name": "Group 13186",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45452",
    "data-name": "Path 45452",
    d: "M123.882.253a114.512,114.512,0,0,0-52.69,8.96c-3.965,1.679-12.492,4.079-10.721,9.626,1.949,6.106,10.728-.31,14-1.676,75.378-31.473,159.84,29.37,149.75,111-7.726,62.494-59.2,102.186-121.992,94.858C33.5,215-8.112,143.125,15.583,78.977c1.313-3.555,5.421-10.464,6-13.244.833-3.989-1.975-7.111-6-5.462-2.725,1.117-7.318,13.25-8.474,16.487C-24.04,163.942,51.92,249.558,142.429,230,272.236,201.961,259.624,9.171,123.882.253",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45453",
    "data-name": "Path 45453",
    d: "M139.605,54.158A77.968,77.968,0,0,0,103.062,60c-3.7,1.53-13.046,4.65-9.117,10.107,2.99,4.153,9.07-.8,12.4-2.157,68.752-27.992,129.922,55.383,80.538,111.567-52.555,59.791-148.31-.464-118.3-73.884,1.277-3.124,7.355-11.621.753-13.062-3.793-.828-5.183,2.238-6.676,5.072-28.283,53.694,15.991,118.283,76.054,114.369,97.69-6.367,98.526-150.558.891-157.85",
    transform: "translate(-16.767 -16.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45454",
    "data-name": "Path 45454",
    d: "M183.331,31.48l-18.9,1.146c-3.957,1.53-4.505,5.2-1.684,8.219,10.439,10.008,20.167,20.849,31.022,30.372,7.392.772,14.913-1.008,22.349-1.037l52.852,52.8a4.417,4.417,0,0,0,6.045-6.033L222.107,64.2l1.342-17.368c.143-3.754.268-4.456-2.091-7.312-5.788-7.007-21.366-22.738-28.381-28.329-3.218-2.564-5.693-3.169-8.212.668a175.892,175.892,0,0,0-1.434,19.62m30.206,30.147c-5.559-.2-11.155,1.353-16.659.766-2.009-3.087-21.319-19.793-21.351-21.3-.049-2.3,14.6,1.735,16.014-5.318.652-3.246.269-7.133.616-10.3.057-.524.25-1.795.806-1.783C194.472,23.723,211.211,43,214.3,45c.587,5.493-.97,11.078-.768,16.626",
    transform: "translate(-154.337 -2.789)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45455",
    "data-name": "Path 45455",
    d: "M153.87,108.061c-4.357-.443-18.051-.6-20.35,3.811-.992,1.905-.876,4.307.985,5.64,2.675,1.916,10.962-1.286,14.831-1.288,23.59-.011,38.715,24.392,30.343,45.877-13.588,34.872-69.574,22.013-63.28-18.456.453-2.912,3.43-8.062-.783-9.875-6.288-2.706-7.869,6.554-8.2,10.788-2.387,30.938,24.371,53.6,54.552,44.57,42.135-12.611,36.538-76.532-8.1-81.068",
    transform: "translate(-32.071 -32.96)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchery);
export default __webpack_public_path__ + "static/media/archery.f0c91611dc1b7f35bfede91e54335a72.svg";
export { ForwardRef as ReactComponent };